import React, { useLayoutEffect, useState } from 'react';
import { CitrusTheme } from '../context/CitrusTheme';
export var Legacy = function (_a) {
    var children = _a.children, _b = _a.darkMode, darkMode = _b === void 0 ? false : _b, _c = _a.darkModeDetection, darkModeDetection = _c === void 0 ? false : _c, _d = _a.noWrapper, noWrapper = _d === void 0 ? false : _d;
    var _e = useState({ name: 'legacy', darkMode: darkMode, darkModeDetection: darkModeDetection }), value = _e[0], setValue = _e[1];
    useLayoutEffect(function () {
        setValue({ name: 'legacy', darkMode: darkMode, darkModeDetection: darkModeDetection });
    }, [darkMode, darkModeDetection, noWrapper]);
    if (noWrapper) {
        return React.createElement(CitrusTheme.Provider, { value: value }, children);
    }
    return (React.createElement(CitrusTheme.Provider, { value: value },
        React.createElement("div", { className: "citrus-legacy" }, children)));
};
